webpackJsonp([2],{

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(303);
module.exports = __webpack_require__(1334);


/***/ }),

/***/ 1334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/styles/common/Common.scss
var Common = __webpack_require__(366);
var Common_default = /*#__PURE__*/__webpack_require__.n(Common);

// EXTERNAL MODULE: ./node_modules/webfontloader/webfontloader.js
var webfontloader = __webpack_require__(111);
var webfontloader_default = /*#__PURE__*/__webpack_require__.n(webfontloader);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(84);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/utils/Feed.js
var Feed = __webpack_require__(470);

// CONCATENATED MODULE: ./src/common/renderFeed.js



function renderFeedItems(data, elem) {
    var isList = elem.hasClass('display-list');
    var characterLimit = elem.attr('data-character-limit');
    var postLimit = elem.attr('data-post-limit');

    data.entries.slice(0, parseInt(postLimit)).forEach(function (item) {
        var thumbnailUrl = isList ? null : item.thumbnail || Object(Feed["b" /* fetchThumbnailUrl */])(item.content);
        var sanitizedContent = isList ? null : Object(Feed["c" /* sanitizeHtml */])(item.content);
        var innerHTML = sanitizedContent ? Object(Feed["a" /* cropHtml */])(sanitizedContent, characterLimit) : null;

        var postsListItem = $('<div class="postlist-item"></div>');
        if (!isList && thumbnailUrl) {
            postsListItem.append('<div class="postlist-thumbnail" style="background-image: url(' + thumbnailUrl + ')" />');
        }
        if (!isList && !thumbnailUrl) {
            postsListItem.append('<div class="postlist-thumbnail thumbnail-notfound" />');
        }

        var itemContent = $('<div class="postlist-content"></div>');
        itemContent.append('<div class="postlist-title"><a href="' + item.link + '" target="_blank">' + item.title + '</a></div>');

        var authorTimeStamp = $('<div class="postlist-timestamp"></div>');
        var authorTimeStampText = item.author ? 'by ' + item.author : '';
        authorTimeStampText = item.author && item.timestamp ? authorTimeStampText + ' / ' : authorTimeStampText;
        authorTimeStampText = item.timestamp ? authorTimeStampText + moment_default()(item.timestamp * 1000).calendar() : authorTimeStampText;

        authorTimeStamp.html(authorTimeStampText);
        itemContent.append(authorTimeStamp);

        if (innerHTML) {
            var itemDescription = $('<div class="postlist-description"/>');
            itemDescription.html(innerHTML);
            itemContent.append(itemDescription);
        }

        postsListItem.append(itemContent);
        elem.append(postsListItem);
    });
}

function fetchFeedData(elem) {
    var feedURL = elem.attr('data-feed-url');
    if (!feedURL) {
        console.warn("No URL found for RSS feed element");
    }

    var bodyJSON = {
        "version": "1.1",
        "id": 1,
        "method": "get_rss_feed",
        "params": [{
            "url": feedURL
        }]
    };

    $.ajax({
        url: '/rssparser',
        type: 'post',
        data: JSON.stringify(bodyJSON),
        dataType: 'json',
        cache: false,
        contentType: 'application/json',
        processData: false,
        success: function success(data) {
            if (data && data.result) {
                renderFeedItems(data.result, elem);
            } else {
                console.warn("Failed to fetch feed data");
            }
        },
        error: function error() {
            console.warn("Failed to fetch feed data");
        }
    });
};

function renderFeed(elems) {
    elems.each(function () {
        var target = $(this);
        var feedData = fetchFeedData(target);
    });
}
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(renderFeedItems, 'renderFeedItems', '/usr/src/app/src/common/renderFeed.js');

    __REACT_HOT_LOADER__.register(fetchFeedData, 'fetchFeedData', '/usr/src/app/src/common/renderFeed.js');

    __REACT_HOT_LOADER__.register(renderFeed, 'renderFeed', '/usr/src/app/src/common/renderFeed.js');
}();

;
// EXTERNAL MODULE: ./src/utils/Utils.js
var Utils = __webpack_require__(13);

// EXTERNAL MODULE: ./src/constants/Fonts.js + 1 modules
var Fonts = __webpack_require__(99);

// EXTERNAL MODULE: ./src/styles/fonts/SvgIcons.font.js
var SvgIcons_font = __webpack_require__(367);
var SvgIcons_font_default = /*#__PURE__*/__webpack_require__.n(SvgIcons_font);

// CONCATENATED MODULE: ./src/render.js
// All JS and CSS needed on render/preview sm page
/* global $ */










var pageWebFonts = SMEditor.webFonts && SMEditor.webFonts.length > 0 ? Object(Utils["w" /* uniqueWebFonts */])(SMEditor.webFonts) : [];

var fontList = pageWebFonts.map(function (font) {
    var webFont = Fonts["d" /* WEB_LOAD_FONT_LIST */].find(function (webFont) {
        return webFont.value === font;
    });
    return webFont && webFont.weights ? webFont.value + ':' + webFont.weights.join(",") : font;
});

if (fontList.length) {
    webfontloader_default.a.load({
        google: {
            families: fontList
        },
        classes: false,
        events: false
    });
}

// Smooth scroll on clicking links
$(document).ready(function () {
    $(function () {
        $('a[href*="#"]:not([href="#"])').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });
    });
    //if there are any slideshows -> initialise them
    if ($('.gallery').length) {
        $('.gallery').slick();
    }
    if ($('.filmstrip-nav').length) {
        $('.filmstrip-nav').on('click', 'a', function () {
            $('#' + $(this).attr('data-nav-for')).slick('slickGoTo', $(this).attr('id'));
        });
    }
    $('[data-nocontextmenu=true]').contextmenu(function () {
        return false;
    });

    // initialise RSS feed apps, if any
    var rssFeeds = $('.rss-feed-app');
    if (rssFeeds.length) {
        renderFeed(rssFeeds);
    }
});
;

var render__temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(pageWebFonts, 'pageWebFonts', '/usr/src/app/src/render.js');

    __REACT_HOT_LOADER__.register(fontList, 'fontList', '/usr/src/app/src/render.js');
}();

;

/***/ })

},[1333]);


// WEBPACK FOOTER //
// render.js